import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useClassName, useWindowSize } from 'common/hooks';
import { SlidersIcon } from 'public/icons';
import { BottomSheet } from '../BottomSheet';

import './filters-menu.less';

const Row = ({ label, children }) => {
  const className = useClassName('FiltersMenu');

  return (
    <div className={className('row')}>
      <span className={className('label')}>{label}</span>
      <div className={className('control')}>{children}</div>
    </div>
  );
};

const FiltersMenu = ({ title, activeCount, onClear, clearLabel, children }) => {
  const className = useClassName('FiltersMenu');
  const { isMobile } = useWindowSize();
  const [isOpen, setIsOpen] = useState(false);
  const container = useRef();

  useEffect(() => {
    if (!isOpen || isMobile) return;

    const handleClickOutside = (e) => {
      if (!container.current.contains(e.target)) setIsOpen(false);
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen, isMobile]);

  const content = (
    <div className={className('content')}>
      {children}
      {onClear && activeCount > 0 && (
        <div className={className('footer')}>
          <button
            type="button"
            className={className('clear')}
            onClick={onClear}>
            {clearLabel}
          </button>
        </div>
      )}
    </div>
  );

  return (
    <div className={className('container')} ref={container}>
      <button
        type="button"
        aria-label={title}
        aria-expanded={isOpen}
        className={className('trigger', isOpen ? 'open' : '')}
        onClick={() => setIsOpen(!isOpen)}>
        <SlidersIcon size={26} />
        {activeCount > 0 && (
          <span className={className('badge')}>{activeCount}</span>
        )}
      </button>
      {isMobile ? (
        <BottomSheet
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          title={title}
          content={content}
        />
      ) : (
        isOpen && <div className={className('panel')}>{content}</div>
      )}
    </div>
  );
};

FiltersMenu.Row = Row;

Row.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.node,
};

FiltersMenu.propTypes = {
  title: PropTypes.string,
  activeCount: PropTypes.number,
  onClear: PropTypes.func,
  clearLabel: PropTypes.string,
  children: PropTypes.node,
};

FiltersMenu.defaultProps = {
  title: 'Filters',
  activeCount: 0,
  clearLabel: 'Clear filters',
};

export default FiltersMenu;
